// Vocabulaire des statuts de TÂCHE (tk_tasks).
//
// ⚠️ TROIS bases de code, TROIS déclarations, aucun module partagé. Toute
// modification doit être portée dans les trois, pas dans deux :
//   1. apps/backoffice/backend/app/models/ticketing.py   (Python, la référence)
//   2. apps/backoffice/frontend/src/constants/taskStatuses.js  (ce fichier)
//   3. apps/my-meteris/src/constants/taskStatuses.ts     (TypeScript)
// Une valeur ajoutée dans une seule des trois est le mode de panne principal de
// ce vocabulaire — et il s'est déjà produit.
//
// Ne pas confondre avec ticketStatuses.js, qui porte les statuts de TICKET.
//
// Les valeurs legacy (in_progress, pending, cancelled à 2 L, closed, deleted)
// proviennent de l'import GLPI. Aucun chemin de création ne les écrit, mais le
// code les lit.
export const TASK_OPEN_STATUSES = ['todo', 'doing', 'in_progress', 'pending'];

export const TASK_TERMINAL_STATUSES = [
  'done', 'canceled', 'cancelled', 'closed', 'deleted', 'information',
];

// Miroir de l'enum `TaskStatus` du backend : les seuls statuts qu'un chemin de
// création ou d'édition écrit réellement. C'est l'ensemble sur lequel les tests
// de couverture des libellés bouclent — une 6ᵉ valeur ajoutée ici sans libellé
// ni couleur rougit, là où un tableau recopié dans le test resterait vert.
export const TASK_STATUS_VALUES = ['todo', 'doing', 'done', 'canceled', 'information'];

// Statuts dont le temps ne compte JAMAIS pour l'étiquette « à facturer » — miroir de
// TASK_NON_BILLABLE_STATUSES (backend app/models/ticketing.py) : la tâche n'a pas eu lieu
// ou n'était qu'une information.
export const TASK_NON_BILLABLE_STATUSES = ['canceled', 'cancelled', 'deleted', 'information'];

export const TASK_STATUS_LABELS = {
  todo: 'À faire',
  doing: 'En cours',
  done: 'Terminé',
  canceled: 'Annulé',
  information: 'Information',
};

export const TASK_STATUS_COLORS = {
  todo: '#6b7d8f',
  doing: '#e67e22',
  done: '#27ae60',
  canceled: '#e74c3c',
  information: '#0ea5e9',
};

export function isTaskOpen(status) {
  return TASK_OPEN_STATUSES.includes(status);
}
